import {
	Component,
	Directive,
	HostListener,
	Input,
	OnInit,
} from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { ShareComponent } from './share/share.component';

@Directive({
	selector: '[app-share-certificate]',
})
export class ShareCertificateComponent implements OnInit {
	@Input() sprintData: any;
	@Input() cohortId: number;

	isCanOpenBox = true;
	constructor(private popoverController: PopoverController) {}

	ngOnInit() {}

	@HostListener('click', ['$event'])
	async open(event) {
		if (this.isCanOpenBox) {
			this.isCanOpenBox = false;
			const modal = await this.popoverController.create({
				component: ShareComponent,
				cssClass: 'learn-class',
				alignment: 'start',
				event: event,
				componentProps: {
					sprintData: {
						certificateUrl: this.sprintData.certificateUrl,
						courseName: this.sprintData.courseName,
						issuedOn: this.sprintData.issuedOn,
						cohortId: this.cohortId,
					},
				},
			});

			modal.style.cssText = `--max-width: 200px;--min-width: 200px;`;

			await modal.present();

			await modal.onDidDismiss();

			this.isCanOpenBox = true;
		}
	}
}
